import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39bdd417"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "upload-fail-dialog-content" }
const _hoisted_2 = { style: {"height":"450px"} }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "pagination flex-end" }
const _hoisted_5 = { class: "footer" }

import { ref, watch, computed } from 'vue'
import CommonDialog from '@/components/common/CommonDialog.vue'
import { t } from '@/plugins/i18n'
import { excelExport } from '@/util/useXlsx'
import { orderExcelKnowApi } from '@/apis/shopcart'
import { isD2C, useSite } from '@/store'

export default /*#__PURE__*/_defineComponent({
  props: {
  list: {
    type: Array,
    default: () => []
  },
  visible: {
    type: Boolean,
    default: false
  },
  // 1 fba 2 其他国际发货
  sendType: {
    type: Number,
    default: 1
  }
},
  emits: ['update:visible'],
  setup(__props, { emit: emits }) {

const props = __props

const show = computed(() => props.visible)

const ok = () => { }
const cancel = () => {
  emits('update:visible', false)
}
const data: any = ref([])
const tableCount = ref(0)
const pageSize = ref(10)
const currentPage = ref(1)
const changeData = () => {
  data.value = props.list.filter((item, index) => {
    return (index > pageSize.value * (currentPage.value - 1) - 1) && (index < pageSize.value * currentPage.value)
  })
}
watch(() => props.list, (value) => {
  tableCount.value = value.length
  changeData()
}, {
  immediate: true
})
watch(currentPage, (value) => {
  changeData()
})
watch(pageSize, (value) => {
  currentPage.value = 1
  changeData()
})
const columns = computed(() => {
  const list = [
    {
      title: t('行目'),
      dataIndex: 'rowNumber'
    },
    {
      title: t('エラーメッセージ'),
      dataIndex: 'errorMessage'
    },
    {
      title: t('平台商品SKU'),
      dataIndex: 'productSku'
    }
  ]
  if (props.sendType === 1) {
    list.push({
      title: t('FNSKU'),
      dataIndex: 'fnSku'
    })
  }
  if (props.sendType !== 1) {
    list.push({
      title: t('客户SKU'),
      dataIndex: 'customerSku'
    })
  }
  return list
})
const downloadFile = () => {
  excelExport({
    headers: columns.value,
    contents: props.list.map((v:any) => ({
      ...v
    })),
    fileName: 'errorlist'
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createBlock(CommonDialog, {
    visible: _unref(show),
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (_isRef(show) ? (show).value = $event : null)),
    "show-close": false,
    width: 1000,
    className: "upload-fail-dialog",
    onOk: ok,
    onCancel: cancel,
    title: _unref(t)('注意2'),
    "close-on-click-modal": false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_table, {
            data: data.value,
            style: {"width":"100%"},
            height: 450
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "rowNumber",
                label: _unref(t)('行目'),
                width: "180"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(_unref(t)('第X行').replace('X',scope.row.rowNumber)), 1)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                prop: "errorMessage",
                label: _unref(t)('エラーメッセージ')
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", {
                    innerHTML: scope.row.errorMessage
                  }, null, 8, _hoisted_3)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_table_column, {
                prop: "productSku",
                label: _unref(t)('平台SKU')
              }, null, 8, ["label"]),
              (__props.sendType === 1)
                ? (_openBlock(), _createBlock(_component_el_table_column, {
                    key: 0,
                    prop: "fnSku",
                    label: _unref(t)('FNSKU')
                  }, null, 8, ["label"]))
                : (_openBlock(), _createBlock(_component_el_table_column, {
                    key: 1,
                    prop: "customerSku",
                    label: _unref(t)('客户SKU')
                  }, null, 8, ["label"]))
            ]),
            _: 1
          }, 8, ["data"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_pagination, {
            total: tableCount.value,
            pageSize: pageSize.value,
            "onUpdate:pageSize": _cache[0] || (_cache[0] = ($event: any) => ((pageSize).value = $event)),
            pageSizes: [10, 20, 30, 50],
            layout: "prev, pager, next, sizes, jumper",
            background: true,
            currentPage: currentPage.value,
            "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((currentPage).value = $event))
          }, null, 8, ["total", "pageSize", "currentPage"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_button, {
            type: "primary",
            class: "btn",
            onClick: downloadFile
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('下载')), 1)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible", "title"]))
}
}

})